import { Page } from "components/page/page.component"
import { View } from "components/view/view.component"
import style from './indicatorRangeAlertConfigs.style.module.css'
import { Filters } from "components/filters/filters.component"
import { FilterType } from "model/filter.model"
import { Table, TableBody, TableCell, TableHead, TableRow  } from 'components/table/table.component'
import { Text } from "components/text/text.component"
import { Button } from "components/button/button.component"
import { FEATURE } from "data/features.data"
import { Icon } from "components/icon/icon.component"
import { Skeleton } from "components/skeleton"
import { ErrorComponent } from "components/errorComponent/error.component"
import { useEffect, useState } from "react"
import { useGetIndicatorRangeAlertConfigsApi } from "api/alertConfig.api"

type IndicatorRangeAlertConfigPageProps = {
    companyId: string
}

export function IndicatorRangeAlertConfigsPage({companyId}: IndicatorRangeAlertConfigPageProps) {

    const [filter, setFilter] = useState<FilterType>({})
    const {loading, get: _getAlerts, error, data: alerts} = useGetIndicatorRangeAlertConfigsApi()

    useEffect(()=>{
        getAlerts()
    }, [filter])

    function getAlerts(){
        _getAlerts({companyId: companyId, indicatorIds: filter.indicators?.map(_ => _.id) ?? []})
    }

    function handleOnFilterChange(filter: FilterType){
        setFilter(filter)
    }

    function handleDeleteConfig(configId: string){
        alert(`deletando configuração de id: ${configId}`)
    }

    function handleAtualizar(): void {
        // atualizar consulta por configurações
        getAlerts()
    }

    return <Page className={style.Page} title="Configurações de Alertas" header menu >
        <View className={style.Content}>
            <Filters 
                companyId={companyId} 
                // showBuildings 
                // showBuildingGroups 
                showIndicators
                indicatorsFor='alert' 
                onChange={handleOnFilterChange}
                canExpand
                expanded={false}
            />
            <View className={style.AddItemContainer} features={[FEATURE.INDICATOR_RECORD_CREATE.id]}>
                <a href={`/${companyId}/config-alerta`}>
                    <Button className={style.AddButton} variant='contained' size='medium' ><Icon primaryContrast >add_circle</Icon>Nova Configuração de Alerta</Button>
                </a>
            </View>
            {loading
            ?  <Skeleton className={style.Skeleton} />
            : ( error ) ? <ErrorComponent >
                    <Button onClick={handleAtualizar} variant='contained' >Atualizar</Button>
                </ErrorComponent>
            : <View className={style.TableContainer}>
                <View className={style.TableContent}>
                {
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><Text type="h4">Indicador</Text></TableCell>
                                {/* <TableCell><Text type="h4">Prédio</Text></TableCell> */}
                                <TableCell><Text type="h4">Mínimo</Text></TableCell>
                                <TableCell><Text type="h4">Máximo</Text></TableCell>
                                <View features={[FEATURE.CONFIG_ALERT_UPDATE.id, FEATURE.CONFIG_ALERT_DELETE.id]}>
                                    <TableCell><Text type='h4'>Ações</Text></TableCell>
                                </View>
                            </TableRow>
                        </TableHead>
                        { !alerts || alerts.length <= 0 ?
                        <TableBody>
                            <TableRow>
                                <TableCell colSpan={5}>
                                    <Text type='h4'>Nenhuma configuração de alerta encontrada.</Text>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                        :
                        <TableBody>
                            {alerts.map(_ => <TableRow>
                                <TableCell><Text type='sm'>{_.indicator.name}</Text></TableCell>
                                {/* <TableCell><Text type='sm'>{(_.building && _.building?.name) ?? '---'}</Text></TableCell> */}
                                <TableCell><Text type='sm'>{_.min ?? '---'}</Text></TableCell>
                                <TableCell><Text type='sm'>{_.max ?? '---'}</Text></TableCell>
                                <View features={[FEATURE.CONFIG_ALERT_UPDATE.id, FEATURE.CONFIG_ALERT_DELETE.id]}>
                                    <TableCell >
                                        <View className={style.TableCellActions} >
                                            <View title='Editar configuração de alerta' features={[FEATURE.CONFIG_ALERT_UPDATE.id]}>
                                            <a href={`/${companyId}/config-alerta/${_.id}`}>
                                                <Icon >edit_square</Icon>
                                            </a>
                                            </View>
                                            <View title='Deletar configuração de alerta' features={[FEATURE.CONFIG_ALERT_DELETE.id]} onClick={() => handleDeleteConfig(_.id)}>
                                                <Icon >delete</Icon>
                                            </View>
                                        </View>
                                    </TableCell>
                                </View>
                            </TableRow>)}
                        </TableBody>
                        }
                    </Table>
                }
                </View>
            </View>
            }
        </View>
    </Page>
}